export interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  category: 'fruit-tea' | 'milk-tea' | 'matcha' | 'coffee' | 'snack';
  image: string;
  tags?: string[];
  stock: 'in-stock' | 'low-stock' | 'out-of-stock';
}

export interface Topping {
  id: string;
  name: string;
  price: number;
  image: string;
  available: boolean;
}

export interface CartItem {
  cartId: string;
  product: Product;
  size: 'regular' | 'large';
  sugar: number;
  ice: 'no' | 'less' | 'regular' | 'extra';
  toppings: Topping[];
  totalPrice: number;
}

export interface User {
  name: string;
  points: number;
  status: 'Gold' | 'Silver' | 'Bronze';
  avatar: string;
}

export enum AppRoute {
  WELCOME = '/',
  HOME = '/home',
  MENU = '/menu',
  CUSTOMIZE = '/customize',
  SUMMARY = '/summary',
  UPSELL = '/upsell',
  PAYMENT = '/payment',
  CONFIRMATION = '/confirmation',
  ADMIN_DASHBOARD = '/admin',
  ADMIN_INVENTORY = '/admin/inventory',
}